<template>
  <v-card class="d-flex align-items-center text-center pa-4 mt-4 sticky-card" :style="{ top: stickyTop, width: cardWidth }">
    <div class="w-100">

      <v-card-text>
        <v-avatar size="140" class="mx-auto avatar-profile" tile
         @click="triggerFileInput">
          <v-icon v-if="!selectedImage && !legajo.photo_url" color="grey lighten-1"
            size="60">mdi-account</v-icon>
          <v-img v-else :src="selectedImage || legajo.photo_url" alt="Foto de perfil" />
        </v-avatar>


        <!-- File input oculto -->
        <input ref="fileInput" type="file"   accept=".png, .jpg, .jpeg" style="display: none" @change="onFileSelected" />
        <p class="text-caption grey--text mt-2 mb-0" v-if="legajo.photo_url == null">
          Seleccione una foto de perfil
        </p>
        <div class="font-weight-bold text-h6 mt-3" v-if="legajo.id > 0">{{ name_legajo }}</div>
        <div class="grey--text" v-if="legajo.id > 0">Legajo: {{ legajo.id }}</div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CardInfo",
  props: {
    legajo: {
      type: Object,
    },
  },
  data() {
    return {
      selectedImage: null,
      name_legajo: this.legajo.id > 0 ? this.legajo.name + " " + this.legajo.surname : "",
      stickyTop: '166px', // Valor inicial
      // La card es position: fixed; se le da el ancho de su columna para que no tape las otras cards
      cardWidth: null,

    };
  },
  mounted() {
    window.addEventListener('scroll', this.adjustStickyTop);
    // La columna cambia de ancho con la ventana y al abrir/cerrar el menu lateral
    this.$nextTick(() => {
      this.adjustWidth();
      if (window.ResizeObserver && this.$el.parentElement) {
        this.resizeObserver = new ResizeObserver(() => this.adjustWidth());
        this.resizeObserver.observe(this.$el.parentElement);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.adjustStickyTop);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    // Ancho de la columna menos su padding. Hasta 1080px la card deja de ser fija (_rrhh.scss) y usa el 100%.
    adjustWidth() {
      const column = this.$el && this.$el.parentElement;
      if (!column || window.innerWidth <= 1080) {
        this.cardWidth = null;
        return;
      }
      const style = window.getComputedStyle(column);
      const width = column.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      this.cardWidth = width > 0 ? width + "px" : null;
    },
    adjustStickyTop() {
      const scrollTop = window.scrollY;
      this.stickyTop = scrollTop <= 20 ? '167px' : '100px';
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          this.selectedImage = e.target.result; // imagen en base64
          this.legajo.photo_file = this.selectedImage
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>
